import { alpha, useTheme } from "@mui/material";

export default function useNavListStyle() {
  const theme = useTheme();
  const listStyle = {
    mt: 0,
    pr: 3,
    pl: 3,
    color: "text.primary",
    "&& .Mui-selected, && .Mui-selected:hover": {
      bgcolor: alpha(theme.palette.primary.main, 0.08),
      borderRadius: "8px",
      "&, & .MuiListItemIcon-root": {
        color:
          theme.palette.mode === "light" ? theme.palette.primary.dark : "white",
      },
    },

    "& .MuiListItemButton-root": {
      borderRadius: "8px",
    },
    // hover states
    "& .MuiListItemButton-root:hover": {
      bgcolor: alpha(theme.palette.primary.main, 0.08),
      "&, & .MuiListItemIcon-root": {
        color:
          theme.palette.mode === "light" ? theme.palette.primary.dark : "white",
      },
    },
  };
  return listStyle;
}
